import React from "react";
//
//

import { Box } from "@mui/material";

import { getFrontDate } from "../date";
import { postfixes } from "../index";
import BloggersTooltipLayout from "../socialNetworks/BloggersTooltipLayout";
import { tooltips } from "../tooltips";

//
const { pcs, rub, percent, volume, day } = postfixes;
//-----------------------------------------
const globalColumns = {
  id: {
    title: "Артикул",
    render: v => v,
  },
  product: {
    title: "Товар",
  },
  product_id: {
    title: "Артикул",
    render: v => v,
  },
  vendor_codes: {
    title: "Количество артикулов",
    sortable: true,
    postfix: pcs,
  },
  vendor_codes_dynamic: {
    title: "Динамика количества артикулов",
    postfix: pcs,
  },
  count_position: {
    title: "Количество артикулов",
    sortable: true,
    postfix: pcs,
  },
  product_with_orders: {
    title: "Артикулов с продажами",
    sortable: true,
    postfix: pcs,
  },
  position_with_orders_percent: {
    title: "Процент артикулов с заказами",
    sortable: true,
    postfix: percent,
  },
  avg_percent_articles_with_orders: {
    title: "Средний % артикулов с продажами",
    sortable: true,
    postfix: percent,
  },
  brand: {
    title: "Бренд",
  },
  brands: {
    title: "Количество брендов",
    sortable: true,
    postfix: pcs,
  },
  brands_count: {
    title: "Количество брендов",
    sortable: true,
    postfix: pcs,
  },
  brands_with_orders: {
    title: "Количество брендов с заказами",
    sortable: true,
    postfix: pcs,
  },
  seller: {
    title: "Поставщик",
  },
  sellers: {
    title: "Количество поставщиков",
    sortable: true,
    postfix: pcs,
  },
  sellers_count: {
    title: "Количество поставщиков",
    sortable: true,
    postfix: pcs,
  },
  sellers_count_dynamic: {
    title: "Динамика количества поставщиков",
    postfix: pcs,
  },
  sellers_with_orders: {
    title: "Количество поставщиков с заказами",
    sortable: true,
    postfix: pcs,
  },
  category: {
    title: "Категория",
  },
  date: {
    title: "Дата",
    sortable: true,
    render: v => getFrontDate(v),
  },
  products: {
    title: "Количество продуктов на сегодня",
    sortable: true,
    postfix: pcs,
  },
  create_date: {
    title: "Дата появления на сайте",
    sortable: true,
    render: v => getFrontDate(v),
  },
  on_site_date: {
    title: "Дата появления на сайте",
    sortable: true,
    render: v => getFrontDate(v),
  },
  post_date: {
    title: "Дата публикации",
    sortable: true,
    render: v => getFrontDate(v, "dd MMMM yyyy"),
  },
  subject: {
    title: "Приоритетный предмет",
  },
  frequency: {
    title: "Частотность запроса",
    sortable: true,
    postfix: pcs,
  },
  frequency_avg: {
    title: "Частотность запроса",
    sortable: true,
    postfix: pcs,
  },
  frequency_per_product30: {
    title: "Количество запросов на 1 товар",
    sortable: true,
    postfix: pcs,
  },
  days30: {
    title: "Частотность за 30 дней",
    sortable: true,
    postfix: pcs,
  },
  days60: {
    title: "Частотность за 60 дней",
    sortable: true,
    postfix: pcs,
  },
  days90: {
    title: "Частотность за 90 дней",
    sortable: true,
    postfix: pcs,
  },
  first_week30: {
    title: "Частотность за 30 дней в самую раннюю неделю за 30 дней",
    sortable: true,
    postfix: pcs,
  },
  first_week60: {
    title: "Частотность за 30 дней в самую раннюю неделю за 60 дней",
    sortable: true,
    postfix: pcs,
  },
  first_week90: {
    title: "Частотность за 30 дней в самую раннюю неделю за 90 дней",
    sortable: true,
    postfix: pcs,
  },
  last_week30: {
    title: "Частотность за 30 дней в самую последнюю неделю за 30 дней",
    sortable: true,
    postfix: pcs,
  },
  last_week60: {
    title: "Частотность за 30 дней в самую последнюю неделю за 60 дней",
    sortable: true,
    postfix: pcs,
  },
  last_week90: {
    title: "Частотность за 30 дней в самую последнюю неделю за 60 дней",
    sortable: true,
    postfix: pcs,
  },
  diff_frequency30: {
    title: "Изменение частотности за 30 дней в количестве запросов",
    sortable: true,
    postfix: pcs,
  },
  diff_frequency60: {
    title: "Изменение частотности за 60 дней в количестве запросов",
    sortable: true,
    postfix: pcs,
  },
  diff_frequency90: {
    title: "Изменение частотности за 90 дней в количестве запросов",
    postfix: pcs,
  },
  diff_percent30: {
    title: "Изменение частотности за 30 дней в процентном соотношении запросов",
    postfix: pcs,
  },
  diff_percent60: {
    title: "Изменение частотности за 60 дней в процентном соотношении запросов",
    postfix: pcs,
  },
  diff_percent90: {
    title: "Изменение частотности за 90 дней в процентном соотношении запросов",
    postfix: pcs,
  },
  rating: {
    title: "Рейтинг",
  },
  rating_dynamic: {
    title: "Динамика рейтинга",
  },
  proceeds: {
    title: "Выручка",
    postfix: rub,
  },
  proceeds_per_position: {
    title: "Выручка на артикул",
    postfix: rub,
  },
  proceeds_avg: {
    title: "Средняя выручка",
    postfix: rub,
  },
  proceeds_percent: {
    title: "Прирост выручки",
    postfix: percent,
  },
  proceeds_diff: {
    title: "Изменение выручки",
    postfix: rub,
  },
  lost_proceeds_diff: {
    title: "Изменение упущенной выручки",
    postfix: rub,
  },
  lost_proceeds_percent: {
    title: "Изменение упущенной выручки",
    postfix: percent,
  },
  proceeds_diff_avg: {
    title: "Ср. прирост выручки",
    postfix: rub,
  },
  proceeds_diff_sum: {
    title: "Суммарная разница в выручке",
    postfix: rub,
  },
  proceeds_dynamic: {
    title: "Динамика выручки",
    postfix: rub,
  },

  lost_proceeds: {
    title: "Упущенная выручка",
    postfix: rub,
  },
  percent_lost_proceeds: {
    title: "Доля упущенной выручки",
    postfix: percent,
  },
  orders: {
    title: "Количество заказов",
    sortable: true,
    postfix: pcs,
  },
  orders_dynamic: {
    title: "Динамика количества заказов",
    postfix: pcs,
  },
  orders_per_position: {
    title: "Заказов на артикул",
    sortable: true,
    postfix: pcs,
  },
  orders_avg: {
    title: "Среднее количество заказов",
    sortable: true,
    postfix: pcs,
  },
  orders_percent: {
    title: "Прирост количества заказов",
    sortable: true,
    postfix: percent,
  },
  lost_orders_percent: {
    title: "Прирост упущенных заказов",
    sortable: true,
    postfix: percent,
  },
  orders_percent_avg: {
    title: "Ср. прирост количества заказов",
    sortable: true,
    postfix: percent,
  },
  orders_diff: {
    title: "Изменение количества заказов",
    sortable: true,
    postfix: pcs,
  },
  lost_orders_diff: {
    title: "Изменение упущенных заказов",
    sortable: true,
    postfix: pcs,
  },
  orders_diff_avg: {
    title: "Ср. прирост количества заказов",
    sortable: true,
    postfix: pcs,
  },
  orders_diff_sum: {
    title: "Суммарная разница в кол-ве заказов",
    sortable: true,
    postfix: pcs,
  },
  orders_share: {
    title: "Доля заказов среди выборки",
    sortable: false,
    postfix: percent,
  },
  lost_orders: {
    title: "Упущенные заказы",
    sortable: true,
    postfix: pcs,
  },
  percent_lost_orders: {
    title: "Доля упущенных заказов",
    sortable: true,
    postfix: percent,
  },
  price: {
    title: "Средняя цена без СПП",
    sortable: true,
    postfix: rub,
  },
  price_dynamic: {
    title: "Динамика средней цены без СПП",
    postfix: rub,
  },
  price_per_position: {
    title: "Средняя цена", // ??
    sortable: true,
    postfix: rub,
  },
  price_avg: {
    title: "Средняя цена",
    sortable: true,
    postfix: rub,
  },
  median_price: {
    title: "Медианная цена",
    sortable: true,
    postfix: rub,
  },
  avg_price: {
    title: "Средняя цена",
    sortable: true,
    postfix: rub,
  },
  demand_coefficient_product: {
    title: "Коэффициент спроса товара",
    sortable: true,
    postfix: pcs,
  },
  potential_orders: {
    title: "Потенциал заказов",
    sortable: true,
    postfix: pcs,
  },
  potential_proceeds: {
    title: "Потенциал выручки",
    sortable: true,
    postfix: rub,
  },
  avg_reviews_top100: {
    title: "Среднее кол-во отзывов у топ 100 товаров по позициям без учета рекламы",
    sortable: true,
    postfix: pcs,
  },
  avg_speed_reviews_top100: {
    title:
      "Средняя скорость набора отзывов у органических товаров (не рекламных АРК + Аукцион) из топ 100",
    sortable: true,
    postfix: pcs,
  },
  percent_proceeds_top30: {
    title: "Доля выручки, приходящаяся на топ 30 товаров от топ 100",
    sortable: true,
    postfix: percent,
  },
  avg_proceeds_product: {
    title: "Средняя выручка на товар",
    sortable: true,
    postfix: rub,
  },
  avg_proceeds_product_sales: {
    title: "Средняя выручка на товар с продажами",
    sortable: true,
    postfix: rub,
  },
  count_products: {
    title: "Кол-во товаров",
    sortable: true,
    postfix: pcs,
  },
  count_products_sales: {
    title: "Кол-во товаров с продажами",
    sortable: true,
    postfix: pcs,
  },
  percent_products_sales: {
    title: "Доля товаров с продажами",
    sortable: true,
    postfix: percent,
  },
  count_products_advertising: {
    title: "Кол-во товаров в рекламе на первой странице",
    sortable: true,
    postfix: pcs,
  },
  percent_products_advertising: {
    title: "Доля товаров в рекламе на первой странице",
    sortable: true,
    postfix: percent,
  },
  count_products_external_traffic: {
    title: "Кол-во товаров с внешним трафиком",
    sortable: true,
    postfix: pcs,
  },
  percent_products_external_traffic: {
    title: "Доля товаров с внешним трафиком",
    sortable: true,
    postfix: percent,
  },
  count_sellers: {
    title: "Кол-во поставщиков",
    sortable: true,
    postfix: pcs,
  },
  count_sellers_sales: {
    title: "Кол-во поставщиков с продажами",
    sortable: true,
    postfix: pcs,
  },
  percent_sellers_sales: {
    title: "Доля поставщиков с продажами",
    sortable: true,
    postfix: percent,
  },
  posts_count: {
    title: "Рекламных публикаций",
    postfix: pcs,
  },
  valueble_posts_count: {
    title: "Суммарное количество значимых постов",
    postfix: pcs,
  },
  valueble_posts_percent: {
    title: "Процент публикаций с высоким влиянием внешки",
    postfix: percent,
  },
  like_count: {
    title: "Количество лайков",
    sortable: true,
    postfix: pcs,
  },
  view_count: {
    title: "Просмотры",
    postfix: pcs,
  },
  record_count: {
    title: "Интеграций артикула",
    tooltip:
      "Количество публикаций артикула в интервале 3-х дней до и 3-х дней после анализируемой публикации на момент сбора данных.",
    sortable: true,
    postfix: pcs,
  },
  proceeds_percent_avg: {
    title: "Ср. прирост выручки",
    postfix: percent,
  },
  sales: {
    title: "Выкупы",
    sortable: true,
    postfix: pcs,
  },
  sales_dynamic: {
    title: "Динамика выкупов",
    postfix: pcs,
  },
  subject_percent_sales: {
    title: "Процент выкупа",
    hint: "Почти у каждого запроса есть приоритетный предмет. В рамках этого поля мы показываем его % выкупа",
    sortable: true,
    postfix: percent,
  },
  subject_fbo: {
    title: "Комиссия FBO",
    sortable: true,
    postfix: percent,
  },
  subject_fbs_to_fbo: {
    title: "Комиссия FBS",
    sortable: true,
    postfix: percent,
  },
  subject_fbs_self_deliver: {
    title: "Комиссия DBS",
    sortable: true,
    postfix: percent,
  },
  subject_fbs_self_deliver_express: {
    title: "Комиссия DBS Express",
    sortable: true,
    postfix: percent,
  },
  deviation_proceeds: {
    title: "Сглаженное отклонение выручки от ее среднего значения",
    sortable: true,
    postfix: percent,
    hint: "Показатель представлен в %. Чем выше %, тем больше выручка анализируемого периода отклоняется от среднего значения. При расчете отклонений мы исключаем факторы влияний общей тенденции рынка (тренда), тем самым, получаем изолированное влияние факторов сезонности спроса.",
  },
  deviation_proceeds_diff: {
    title: "Сглаженное отклонение выручки от ее среднего значения с учетом внешних колебаний",
    sortable: true,
    postfix: percent,
    hint: "Показатель представлен в %. Чем выше %, тем больше выручка анализируемого периода отклоняется от среднего значения. При расчете отклонений мы исключаем факторы влияний общей тенденции рынка (тренда), тем самым, получаем изолированное влияние факторов сезонности спроса.",
  },
  weighted_price: {
    title: "Средний чек без СПП",
    sortable: true,
    postfix: rub,
  },
  weighted_price_per_position: {
    title: "Средний чек на артикул",
    sortable: true,
    postfix: rub,
  },
  damping_coefficient: {
    title: "Коэффициент демпинга",
    sortable: true,
    postfix: percent,
    hint: tooltips.damping_coefficient,
  },
  damping_coefficient_per_position: {
    title: "Коэффициент демпинга",
    sortable: true,
    postfix: percent,
    hint: tooltips.damping_coefficient,
  },
  sma_price: {
    title: "Цена",
    sortable: true,
    postfix: rub,
  },
  products_with_orders: {
    title: "Артикулов с продажами",
    sortable: true,
    postfix: percent,
  },
  share_products_with_orders: {
    title: "% артикулов с продажами",
    sortable: true,
    postfix: percent,
  },
  dynamic_proceeds_percent: {
    title: "Изменение выручки",
    sortable: true,
    postfix: percent,
  },
  dynamic_lost_proceeds_percent: {
    title: "Изменение упущенной выручки",
    sortable: true,
    postfix: percent,
    // hint: "Разница в % между первым и последним днем анализируемого периода",
  },
  dynamic_orders_percent: {
    title: "Изменение количества заказов",
    sortable: true,
    postfix: percent,
  },
  dynamic_price_percent: {
    title: "Изменение средней цены без СПП",
    sortable: true,
    postfix: percent,
  },
  discount: {
    title: "Общая скидка без СПП",
    sortable: true,
    postfix: percent,
  },
  discount_dynamic: {
    title: "Динамика общей скидки без СПП",
    postfix: percent,
  },
  quantity: {
    // title: "Остатки на конец периода",
    title: "Товарные остатки",
    sortable: true,
    postfix: pcs,
  },
  quantity_dynamic: {
    title: "Динамика товарных остатков",
    postfix: pcs,
  },
  in_stock_percent: {
    sortable: true,
    title: "Доля дней в наличии",
    postfix: percent,
  },
  in_stock_days: {
    title: "Дней в наличии",
    sortable: true,
  },
  out_of_stock_days: {
    title: "Дней отсутствовал",
    sortable: true,
  },
  in_stock_orders_avg: {
    title: "Заказов в день при наличии товаров",
    sortable: true,
    postfix: pcs,
  },
  in_stock_proceeds: {
    title: "Выручка в день при наличии товаров",
    sortable: true,
    postfix: rub,
  },
  reviews: {
    title: "Количество отзывов на конец периода",
    sortable: true,
    postfix: pcs,
  },
  reviews_dynamic: {
    title: "Динамика количества отзывов",
    postfix: pcs,
  },
  avg_proceeds_per_article: {
    title: "Средняя выручка на артикул",
    sortable: true,
    postfix: rub,
  },
  avg_proceeds_per_article_with_orders: {
    title: "Средняя выручка на артикул с продажами",
    sortable: true,
    postfix: rub,
  },
  avg_orders_per_article: {
    title: "Среднее количество заказов на артикул",
    sortable: true,
    postfix: pcs,
  },
  avg_orders_per_article_with_orders: {
    title: "Среднее количество заказов на артикул с продажами",
    sortable: true,
    postfix: pcs,
  },
  dynamic_vendor_codes_percent: {
    title: "Изменение количества артикулов",
    sortable: true,
    postfix: percent,
  },
  likes: {
    title: "Количество лайков",
    sortable: true,
    postfix: pcs,
  },
  accruals_for_sale_avg: {
    title: "Цена товара с учетом скидок",
    postfix: rub,
    sortable: true,
  },
  amount_avg: {
    title: "Стоимость реализации, приведенная к единице товара",
    postfix: rub,
    sortable: true,
  },
  product_cost: {
    title: "Стоимость производства / закупочная цена товара",
    postfix: rub,
    sortable: true,
  },
  sale_commission_avg: {
    title: "Комиссия маркетплейса",
    postfix: rub,
    sortable: true,
  },
  packaging_cost: {
    title: "Маркировка и упаковка",
    postfix: rub,
    sortable: true,
  },
  delivery_cost: {
    title: "Логистика вне маркетплейса",
    postfix: rub,
    sortable: true,
  },
  design_cost: {
    title: "Оформление карточек",
    postfix: rub,
    sortable: true,
  },
  promotion_cost: {
    title: "Маркетинг и внешнее продвижение",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_fulfillment: {
    title: "Сборка заказа",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_dropoff_ff: {
    title: "Обработка отправления (ФФ)",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_dropoff_pvz: {
    title: "Обработка отправления (ПВЗ)",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_dropoff_sc: {
    title: "Обработка отправления (SC)",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_direct_flow_logistic: {
    title: "Логистика",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_direct_flow_trans: {
    title: "Магистраль",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_deliv_to_customer: {
    title: "Последняя миля",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_return_after_deliv_to_customer: {
    title: "Обработка возврата",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_return_flow_logistic: {
    title: "Обратная логистика",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_return_flow_trans: {
    title: "Обратная магистраль",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_return_not_deliv_to_customer: {
    title: "Обработка отмен",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_return_part_goods_customer: {
    title: "Обработка невыкупа",
    postfix: rub,
    sortable: true,
  },
  marketplace_redistribution_of_acquiring_operation: {
    title: "Оплата эквайринга",
    postfix: rub,
    sortable: true,
  },
  marketplace_not_delivered_cost_item: {
    title: "Возврат невостребованного товара от покупателя на склад",
    postfix: rub,
    sortable: true,
  },
  marketplace_return_after_delivery_cost_item: {
    title: "Возврат от покупателя на склад после доставки",
    postfix: rub,
    sortable: true,
  },
  marketplace_delivery_cost_item: {
    title: "Доставка товара до покупателя",
    postfix: rub,
    sortable: true,
  },
  marketplace_sale_reviews_item: {
    title: "Приобретение отзывов на платформе",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_pickup: {
    title: "Выезд транспортного средства по адресу продавца для забора отправлений Pick-up",
    postfix: rub,
    sortable: true,
  },
  item_advertisement_for_supplier_logistic: {
    title: "Доставка товаров на склад Ozon кросс-докинг",
    postfix: rub,
    sortable: true,
  },
  operation_marketplace_service_storage: {
    title: "Размещения товаров",
    postfix: rub,
    sortable: true,
  },
  marketplace_marketing_action_cost_item: {
    title: "Продвижение товаров",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_installment: {
    title: "Продвижение и продажа в рассрочку",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_marking_items: {
    title: "Обязательная маркировка товаров",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_flexible_payment_schedule: {
    title: "Гибкий график выплат",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_return_from_stock: {
    title: "Комплектация товаров для вывоза продавцом",
    postfix: rub,
    sortable: true,
  },
  item_advertisement_for_supplier_logistic_seller: {
    title: "Транспортно-экспедиционные услуги",
    postfix: rub,
    sortable: true,
  },
  marketplace_return_storage_service_at_the_pickup_point_fbs_item: {
    title: "Краткосрочное размещение возврата FBS",
    postfix: rub,
    sortable: true,
  },
  marketplace_return_storage_service_in_the_warehouse_fbs_item: {
    title: "Долгосрочное размещение возврата FBS",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_delivery_kgt: {
    title: "Доставка крупногабаритного товара (КГТ)",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_premium_cashback_individual_points: {
    title: "Услуга продвижения «Бонусы продавца»",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_premium_promotion: {
    title: "Услуга продвижение Premium, фиксированная комиссия",
    postfix: rub,
    sortable: true,
  },
  operation_marketplace_with_holding_for_undeliverable_goods: {
    title: "Удержание за недовложение товара",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_dropoff_ppz: {
    title: "Услуга drop-off в пункте приёма заказов",
    postfix: rub,
    sortable: true,
  },
  marketplace_service_item_redistribution_returns_pvz: {
    title: "Перевыставление возвратов на ПВЗ",
    postfix: rub,
    sortable: true,
  },
  gross_margin: {
    title: "Валовая маржа",
    sortable: true,
    postfix: rub,
  },
  gross_margin_to_cost_share: {
    title: "Отношение валовой маржи к себестоимости",
    sortable: true,
    postfix: percent,
  },
  gross_margin_to_realization_price_share: {
    title: "Отношение валовой маржи к стоимости реализации",
    sortable: true,
    postfix: percent,
  },
  accruals_for_sale: {
    title: "Стоимость товара с учетом скидок",
    sortable: true,
    postfix: rub,
  },
  sale_commission: {
    title: "Комиссия",
    sortable: true,
    postfix: rub,
  },

  preparation_cost: {
    title: "Предподготовка",
    sortable: true,
    postfix: rub,
  },
  gmroi: {
    title: "GM / запасы (GMROI)",
    sortable: true,
    postfix: percent,
  },
  gross_margin_to_product_cost: {
    title: "GM / себестоимость",
    sortable: true,
    postfix: percent,
  },
  gross_margin_to_realization: {
    title: "GM / реализация",
    sortable: true,
    postfix: percent,
  },
  demand_coefficient: {
    title: "Коэффициент демпинга",
    postfix: percent,
    sortable: true,
  },
  sale_quantity: {
    title: "Количество продаж",
    sortable: true,
    postfix: pcs,
  },
  sale_value: {
    title: "Сумма продаж",
    sortable: true,
    postfix: rub,
    hint: "Фактическая стоимость (с учетом всех скидок) проведенной операции по продаже товаров маркетплейсом покупателям",
  },
  return_quantity: {
    title: "Количество возвратов",
    sortable: true,
    postfix: pcs,
  },
  return_value: {
    title: "Сумма возвратов",
    sortable: true,
    postfix: rub,
    hint: "Фактическая стоимость проведенной операции по возврату товаров покупателями маркетплейсу",
  },
  commission: {
    title: "Комиссия",
    sortable: true,
    postfix: rub,
    hint: "Сумма фактически начисленной комиссии маркетплейса, включающей вознаграждение комиссионера, по перевозке, за выдачу и возврат товаров на ПВЗ",
  },
  acquiring_fee: {
    title: "Эквайринг",
    sortable: true,
    postfix: rub,
  },
  delivery: {
    title: "Доставка",
    sortable: true,
    postfix: rub,
    hint: "Затраты на логистику WB без учёта невыкупов и отмен",
  },
  ride: {
    title: "Покатушки",
    sortable: true,
    postfix: rub,
  },
  penalty: {
    title: "Штрафы",
    sortable: true,
    postfix: rub,
  },
  acceptance_value: {
    title: "Приёмка",
    sortable: true,
    postfix: rub,
  },
  paid_storage_value: {
    title: "Хранение",
    sortable: true,
    postfix: rub,
  },
  advert_value: {
    title: "Продвижение",
    sortable: true,
    postfix: rub,
  },
  media: {
    title: "Медиа",
    sortable: true,
    postfix: rub,
  },
  additional_payment: {
    title: "Доплаты",
    sortable: true,
    postfix: rub,
  },
  defect: {
    title: "Брак",
    sortable: true,
    postfix: rub,
  },
  losses: {
    title: "Потери",
    sortable: true,
    postfix: rub,
  },
  withholding: {
    title: "Удержания",
    sortable: true,
    postfix: rub,
  },
  other_payment: {
    title: "Прочее",
    sortable: true,
    postfix: rub,
    hint: "Сумма операций, не относящихся непосредственно к продаже либо возврату",
  },
  wb_service: {
    title: "Сумма услуг WB",
    sortable: true,
    postfix: rub,
  },
  nds: {
    title: "НДС",
    sortable: true,
    postfix: rub,
  },
  sale_avg_bill: {
    title: "Средний чек",
    sortable: true,
    postfix: rub,
    hint: "Отношение суммы продаж к количеству продаж",
  },
  return_share: {
    title: "Доля возвратов",
    sortable: true,
    postfix: percent,
    hint: "Отношение количества возвратов к количеству продаж (в пределах границ периода)",
  },
  cancel_share: {
    title: "Доля отмен",
    sortable: true,
    postfix: percent,
    hint: "Отношение количества отмен к количеству продаж (в пределах границ периода)",
  },
  wb_service_share: {
    title: "Доля затрат на WB",
    sortable: true,
    postfix: percent,
    hint: "Отношение затрат на WB к выручке",
  },
  delivery_quantity: {
    title: "Кол-во прямых доставок (к клиенту)",
    sortable: true,
    postfix: pcs,
  },
  return_deliveries_quantity_on_return: {
    title: "Кол-во обратных доставок при возврате",
    sortable: true,
    postfix: pcs,
  },
  return_deliveries_quantity_on_cancel: {
    title: "Кол-во обратных доставок при отмене",
    sortable: true,
    postfix: pcs,
  },
  return_deliveries_value_on_return: {
    title: "Стоимость обратных доставок при возврате",
    sortable: true,
    postfix: rub,
  },
  ride_to_delivery: {
    title: "Доля покатушек от логистики продаж",
    sortable: true,
    postfix: percent,
  },
  penalty_quantity: {
    title: "Количество штрафов",
    sortable: true,
    postfix: pcs,
  },
  additional_payment_quantity: {
    title: "Количество доплат",
    sortable: true,
    postfix: pcs,
  },
  barcodes_count: {
    title: "Количество товара",
    sortable: true,
    postfix: pcs,
  },
  volume: {
    title: "Объем товара в литро-днях",
    sortable: true,
    postfix: volume,
  },
  pallet_count: {
    title: "Количество палет",
    sortable: true,
    postfix: pcs,
  },
  warehouse_price: {
    title: "Сумма хранения",
    sortable: true,
    postfix: rub,
  },
  calc_type: {
    title: "Способ расчета",
    sortable: true,
  },
  acceptance_count: {
    title: "Количество приёмки",
    sortable: true,
    postfix: pcs,
  },
  views: {
    title: "Количество просмотров",
    sortable: true,
    postfix: pcs,
  },
  clicks: {
    title: "Количество кликов",
    sortable: true,
    postfix: pcs,
  },
  atbs: {
    title: "Количество добавлений товаров в корзину",
    sortable: true,
    postfix: pcs,
  },
  sum_price: {
    title: "Сумма заказов",
    sortable: true,
    postfix: rub,
  },
  ctr: {
    title: "CTR",
    sortable: true,
    postfix: percent,
    hint: "Click-Through Rate – показатель кликабельности (Количество кликов / Количество просмотров)",
  },
  cpc: {
    title: "CPC",
    sortable: true,
    postfix: rub,
    hint: "Cost per Click – плата за клик (Расход на рекламу / Количество кликов)",
  },
  cr: {
    title: "CR",
    sortable: true,
    postfix: percent,
    hint: "Conversion Rate – коэффициент конверсии или просто “в народе” конверсия (Количество заказов / Количество кликов)",
  },
  cpm: {
    title: "CPM",
    sortable: true,
    postfix: rub,
    hint: "Cost per Mille – плата за 1000 показов (Расход на рекламу / Количество просмотров * 1000)",
  },
  cpa: {
    title: "CPO",
    sortable: true,
    postfix: rub,
    hint: "Cost per Order – средняя стоимость привлечения заказа (Расход на рекламу / Количество заказов)",
  },
  sum: {
    title: "Затраты",
    sortable: true,
    postfix: rub,
  },
  romi: {
    title: "ROMI",
    sortable: true,
    postfix: percent,
    hint: "Return on marketing investment – коэффициент возврата маркетинговых инвестиций ((Доход от рекламы – Расход на рекламу) / Расход на рекламу)",
  },
  roas: {
    title: "ROAS",
    sortable: true,
    postfix: percent,
    hint: "Return on ad spend – коэффициент возврата рекламных затрат (Доход от рекламы / Расход на рекламу)",
  },
  car: {
    title: "CAR",
    sortable: true,
    postfix: percent,
    hint: "Cart Abandonment Rate – коэффициент брошенных корзин (1 – Количество заказов / Количество добавлений в корзину)",
  },
  crr: {
    title: "ДРР",
    sortable: true,
    postfix: percent,
    hint: "Доля рекламных расходов – коэффициент отношения рекламных расходов к доходам от этой рекламы (Расход на рекламу / Доход от рекламы)",
  },
  realization_value: {
    title: `Сумма реализации`,
    sortable: true,
    hint: "Стоимость продаж, уменьшенная на стоимость возвратов",
    postfix: rub,
  },
  kvw_prc_commission: {
    title: "Комиссия WB",
    hint: "Средняя комиссия маркетплейса по тарифам Wildberries в соответствии с разделом 12 оферты",
    sortable: true,
    postfix: percent,
  },
  spp_prc_discount: {
    title: "Скидка WB",
    hint: "Средний размер скидки у покупателя, предоставляемой Wildberries",
    sortable: true,
    postfix: percent,
  },
  reward: {
    title: "Вознаграждение WB",
    hint: "Сумма фактически начисленного вознаграждения Wildberries",
    sortable: true,
    postfix: rub,
  },
  commission_acquiring_fee: {
    title: "Эквайринг (входящий в комиссию, до 01-04-2024)",
    sortable: true,
    postfix: rub,
  },
  estimated_commission: {
    title: "Комиссия /расчётная с СПП/",
    sortable: true,
    postfix: rub,
  },
  estimated_commission_to_price_share: {
    title: "Расчётная комиссия с СПП к цене товара со скидкой",
    sortable: true,
    postfix: percent,
  },
  non_commission_acquiring_fee: {
    title: "Эквайринг (не входящий в комиссию, после 01-04-2024)",
    sortable: true,
    postfix: rub,
  },
  ppvz_reward: {
    title: "Поверенный",
    sortable: true,
    postfix: rub,
  },
  spp_prc_discount_value: {
    title: `Сумма скидки`,
    sortable: true,
    postfix: rub,
  },
  realization_quantity: {
    title: `Количество реализованного товара`,
    sortable: true,
    postfix: pcs,
  },
  realization_quantity_share: {
    title: `Доля от общего количества реализованного товара`,
    sortable: true,
    postfix: percent,
  },
  realization_quantity_group_label: {
    title: `Принадлежность к ABC-группе по количеству реализованного товара`,
  },
  proceeds_share: {
    title: `Доля от общей суммы выручки`,
    sortable: true,
    postfix: percent,
  },
  proceeds_group_label: {
    title: `Принадлежность к ABC-группе по выручке`,
  },
  gross_margin_share: {
    title: `Доля от общей суммы валовой маржи`,
    sortable: true,
    postfix: percent,
  },
  gross_margin_group_label: {
    title: `Принадлежность к ABC-группе по валовой марже`,
  },
  synthetic_abc_group_label: {
    title: "Группа синтетического ABC",
  },
  xyz_label: {
    title: `Группа XYZ`,
  },
  advert_quantity: {
    title: "Количество кампаний",
    sortable: true,
    postfix: pcs,
  },
  product_quantity: {
    title: "Количество товаров",
    sortable: true,
    postfix: pcs,
  },
  avg_position: {
    title: "Средняя позиция",
    sortable: true,
  },
  median_position: {
    title: "Медианная позиция",
    sortable: true,
  },
  open_card: {
    title: "Открытий карточки",
    sortable: true,
    postfix: pcs,
  },
  cart_to_order: {
    title: "Конверсия в заказ из корзины",
    sortable: true,
    postfix: percent,
  },
  add_to_cart: {
    title: "Положили в корзину",
    sortable: true,
    postfix: pcs,
  },
  open_to_cart: {
    title: "Конверсия в корзину из перехода",
    sortable: true,
    postfix: percent,
  },
  logistic_buyout: {
    title: "Логистика выкупов",
    sortable: true,
    postfix: rub,
  },
  logistic_cancel: {
    title: "Логистика отмен",
    sortable: true,
    postfix: rub,
  },
  logistic_return: {
    title: "Логистика возвратов",
    sortable: true,
    postfix: rub,
  },
  realization_price: {
    title: `Стоимость реализации, приведенная к единице товара`,
    sortable: true,
    postfix: rub,
  },
  predict_weighted_price_coeff: {
    title: `Коэффициент роста среднего чека`,
    sortable: true,
  },
  predict_orders_per_article_coeff: {
    title: `Коэффициент роста заказов`,
    sortable: true,
  },
  predict_proceeds_per_article_coeff: {
    title: `Коэффициент роста выручки`,
    sortable: true,
  },
  gross_margin_to_realization_value_share: {
    title: "Отношение валовой маржи к сумме реализации",
    sortable: true,
    postfix: percent,
    hint: "Отношение валовой маржи (валовой прибыли) к сумме реализации",
  },
  avg_percent_brands_with_orders: {
    title: "Средний % брендов с продажами",
    sortable: true,
    postfix: percent,
  },
  avg_percent_sellers_with_orders: {
    title: "Средний % поставщиков с продажами",
    sortable: true,
    postfix: pcs,
  },

  costs: {
    title: "Расходы",
    sortable: true,
    postfix: rub,
  },
  profit: {
    title: "Выручка",
    sortable: true,
    postfix: rub,
  },
  models_orders: {
    title: "Заказы модели",
    sortable: true,
    postfix: pcs,
  },
  models_money: {
    title: "Выручка с заказов модели",
    sortable: true,
    postfix: rub,
  },
  cost: {
    title: "Стоимость",
    sortable: true,
    postfix: rub,
  },
  bid: {
    title: "Ставка",
    sortable: true,
    postfix: percent,
  },
  bid_value: {
    title: "Ставка в рублях",
    sortable: true,
    postfix: rub,
  },
  money_spent: {
    title: "Расход",
    sortable: true,
    postfix: rub,
  },
  sum_search: {
    title: "Сумма заказов по поиску",
    sortable: true,
    postfix: rub,
  },
  sum_other: {
    title: "Сумма заказов по другим источникам",
    sortable: true,
    postfix: rub,
  },
  ctr_search: {
    title: "CTR по поиску",
    sortable: true,
    postfix: percent,
  },
  ctr_other: {
    title: "CTR по другим источникам",
    sortable: true,
    postfix: percent,
  },
  cpm_search: {
    title: "CPM по поиску",
    sortable: true,
    postfix: rub,
  },
  cpm_other: {
    title: "CPM по другим источникам",
    sortable: true,
    postfix: rub,
  },
  cpc_search: {
    title: "CPC по поиску",
    sortable: true,
    postfix: rub,
  },
  cpc_other: {
    title: "CPC по другим источникам",
    sortable: true,
    postfix: rub,
  },
  views_search: {
    title: "Просмотры по поиску",
    sortable: true,
    postfix: pcs,
  },
  views_other: {
    title: "Просмотры по другим источникам",
    sortable: true,
    postfix: pcs,
  },
  clicks_search: {
    title: "Клики по поиску",
    sortable: true,
    postfix: pcs,
  },
  clicks_other: {
    title: "Клики по другим источникам",
    sortable: true,
    postfix: pcs,
  },
  avg_discount: {
    title: "Средняя скидка",
    sortable: true,
    postfix: percent,
  },
  order_quantity: {
    title: "Заказы",
    sortable: true,
    postfix: pcs,
  },
  stock_end: {
    title: "Остатки на конец периода",
    sortable: true,
    postfix: pcs,
  },
  sparkline: {
    title: `Динамика выручки`,
    postfix: rub,
    sortable: false,
  },
  stock_days: {
    title: "Оборачиваемость",
    sortable: true,
    postfix: day,
  },
  w_proceeds: {
    title: "Расчетная выручка",
    postfix: rub,
  },
  w_proceeds_sum: {
    title: "Общая расчётная выручка",
    postfix: rub,
    tooltip: (
      <BloggersTooltipLayout>
        Общая расчётная выручка от интеграций блогера за всё время.
      </BloggersTooltipLayout>
    ),
  },
  w_proceeds_avg: {
    title: "Ср. расчетная выручка",
    postfix: rub,
  },
  view_avg: {
    title: "Ср. кол-во просмотров",
    postfix: pcs,
  },
  reactions_avg: {
    title: "Реакций на публикацию",
    postfix: pcs,
  },
  w_price: {
    title: "Ср. чек после публикации",
    postfix: rub,
  },
  w_price_diff_avg: {
    title: "Ср. прирост чека после публикации",
    postfix: rub,
  },
  w_orders_avg: {
    title: "Ср. расчетные заказы после публикации",
    postfix: pcs,
  },
  w_price_percent_avg: {
    title: "Ср. прирост чека  после публикации",
    postfix: percent,
    tooltip: (
      <>
        <b>Средний прирост чека после публикации.</b>
        <br />В расчет данного показателя берутся последние известные посты за выбранный период
      </>
    ),
  },
  w_price_diff: {
    title: "Прирост ср. чека после публикации",
    postfix: rub,
  },
  w_price_percent: {
    title: "Прирост ср. чека после публикации",
    postfix: percent,
  },
  subscriber_count: {
    title: "Размер блогера",
    postfix: pcs,
    tooltip: (
      <>
        Распределение блогеров по количеству подписчиков:
        <ul style={{ textAlign: "start" }}>
          <li>
            <b>Малый</b> - до 5 000 подписчиков.
          </li>
          <li>
            <b>Средний</b> - от 5 000 до 50 000 подписчиков.
          </li>
          <li>
            <b>Крупный</b> - от 50 000 подписчиков.
          </li>
        </ul>
      </>
    ),
  },
  er: {
    title: "ER",
    postfix: percent,
    tooltip: (
      <span>
        <strong>ER (Engagement Rate)</strong> показывает, как активно подписчики взаимодействуют с
        контентом: лайки, комментарии, репосты, сохранения. <br />
        <br />
        <strong>Формула:</strong> (лайки + комментарии + репосты + сохранения) / подписчики × 100%
        <br />
        Данных может не быть, так как некоторые блогеры отключают реакции на своих публикациях
      </span>
    ),
  },
  err: {
    title: "ERR",
    postfix: percent,
    tooltip: (
      <span>
        <strong>ERR (Engagement Rate by Reach)</strong> отражает вовлеченность среди всех, кто
        увидел пост.
        <br />
        <br />
        <strong>Формула:</strong> реакции / охват × 100%
        <br />
        Данных может не быть, так как некоторые блогеры отключают реакции на своих публикациях
      </span>
    ),
  },
  success_level: {
    title: "Успешность публикации",
    tooltip: (
      <>
        <b>Успешность интеграции, выраженная в количестве заказов, полученных от нее.</b>
        <ul style={{ textAlign: "start" }}>
          <li>
            <b>Низкая</b> - до 10 заказов.
          </li>
          <li>
            <b>Средняя</b> - от 10 до 50 заказов.
          </li>
          <li>
            <b>Высокая</b> - от 50 до 100 заказов.
          </li>
          <li>
            <b>Очень высокая</b> - от 100 и более.
          </li>
        </ul>
      </>
    ),
  },
  w_orders: {
    title: "Расчетные заказы",
    postfix: pcs,
  },
  reactions_count: {
    title: "Количество реакций",
    postfix: pcs,
  },
  er_avg: {
    title: "Средний ER",
    postfix: percent,
  },
  err_avg: {
    title: "Средний ERR",
    postfix: percent,
  },
  delivery_days: {
    title: "Срок доставки товаров от поставщика",
    postfix: day,
  },
  min_quantity_for_income: {
    title: "Минимальное количество товара для заказа",
    postfix: pcs,
  },
  box_quantity: {
    title: "Кратность короба",
    postfix: pcs,
  },
  prepayment: {
    title: "Предоплата",
    postfix: percent,
  },
  on_income: {
    title: "По факту поставки",
    postfix: percent,
  },
  after_realization: {
    title: "После реализации",
    postfix: percent,
  },
  group_type: {
    title: "Тип",
    render: val => {
      switch (val) {
        case "expense":
          return "Расход";

        case "income":
          return "Доход";
        default:
          return "Неизвестный тип";
      }
    },
  },
  is_recurring: {
    title: "Периодичность",
    render: val => (val ? "Регулярный" : "Разовый"),
  },
  group_name: {
    title: "Статья",
  },
  description: {
    title: "Комментарии",
  },
  amount: {
    title: "Сумма",
    postfix: postfixes.rub,
  },
  marketplace: {
    title: "Маркетплейс",
  },
  counterparty_name: {
    title: "Контрагент",
  },
  subject_mp: {
    title: "Предмет", // subject был уже занят
  },
  nds_amount: {
    title: "НДС",
    render: val => {
      if (val.nds !== undefined && val.nds !== null) {
        return `${val.nds * 100}% (${Math.round(val.amount * val.nds)} ${postfixes.rub})`;
      }
    },
  },
  reviews_diff_proceeds: {
    title: "ВНО",
    tooltip: (
      <Box sx={{ textAlign: "start" }}>
        <b>Выручка от новых отзывов.</b>
        <br />
        <br />
        <>Рассчитывается за анализируемый период как:</>
        <br />
        <br />
        <>(Число новых отзывов) × (Средняя цена товара без СПП).</>
        <br />
        <br />
        <i>
          Для склеек учитывается прирост отзывов на всю группу, если рейтинг у товаров в ней
          объединен.
        </i>
        <br />
        <br />
        <>
          Показатель используется для примерной оценки минимального количества заказов артикула или
          склейки (если рейтинг товаров объединен), когда данные об остатках недоступны.
        </>
        <br />
        <br />
        <>
          {" "}
          Поскольку у разных товаров разная конверсия заказов в отзывы, для оценки выручки через ВНО
          (при условии, что остатки были ограничены) можно использовать два метода:
        </>
        <br />
        <br />
        <>
          <b>Метод 1.</b> Проанализировать соотношение «заказы / отзывы» за период, когда данные
          были полными (например, до 15.09.25), и применить это соотношение к текущим данным об
          отзывах.
        </>
        <br />
        <br />
        <>
          <b>Метод 2.</b> Умножить количество отзывов (ВНО) на коэффициент от 3 до 5.
        </>
      </Box>
    ),
    postfix: postfixes.rub,
  },
};

export default globalColumns;
